export default "data:image/svg+xml,%3Cpath%20d%3D%22M7.41%208.59%2012%2013.17l4.59-4.58L18%2010l-6%206-6-6%201.41-1.41z%22%2F%3E"